import { render, staticRenderFns } from "./WordInfo.vue?vue&type=template&id=0d93dec1&scoped=true&"
import script from "./WordInfo.vue?vue&type=script&lang=js&"
export * from "./WordInfo.vue?vue&type=script&lang=js&"
import style0 from "./WordInfo.vue?vue&type=style&index=0&id=0d93dec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d93dec1",
  null
  
)

export default component.exports